<template>
    <b-modal
            id="report-measurement-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">
        <b-overlay :show="isLoading" rounded="sm">

            <b-alert :show="showInProgressWarning" variant="warning">Session Recording is in-progress. Analysis report may not be available, measurement data tables are available.</b-alert>

            <form ref="form" v-on:submit.prevent="noop">

                <b-form-group v-if="primaryImageValid">
                  <div>Organization Image</div>
                  <div class="my-3 p-1" style="width: 260px; margin-left: auto; margin-right: auto; border: 1px solid #666666;">
                    <img style="max-width: 100%; max-height: 100%; display: block; margin-left: auto; margin-right: auto;"
                         v-bind:src="'data:image/png;base64,'+primaryImageValue" alt="( Primary Image 350x100 )" />
                  </div>
                </b-form-group>

                <b-form-group
                        label="Data averaging time range"
                        label-for="average-input">
                    <b-form-select id="average-input" v-model="selectedAverage" :options="averageOptions"></b-form-select>
                </b-form-group>

                <b-form-group
                        label="Data table format"
                        label-for="format-input">
                    <b-form-select id="format-input" v-model="selectedFormat" :options="formatOptions"></b-form-select>
                </b-form-group>

                <b-form-group
                    label="Speed Units"
                    label-for="format-input">
                  <b-form-select id="format-input" v-model="selectedUnit" :options="unitOptions"></b-form-select>
                </b-form-group>
            </form>

        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()">
                Download
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '../../api/vo2api'

    export default {
        name: "MeasurementReportModal",
        props: [ "includePDFReport", "includeDataTables", "includeExtendedDataTables"],
        data() {
            return {

                isLoading: false,

                showModal: false,

                title: "Report Options",


                nameValue: null,

                primaryImageValid: false,
                primaryImageValue: null,

                showValidation: false,

                selectedAverage: 30,
                averageOptions: [
                    { value: 1, text: '1 Seconds' },
                    { value: 5, text: '5 Seconds' },
                    { value: 10, text: '10 Seconds' },
                    { value: 15, text: '15 Seconds' },
                    { value: 30, text: '30 Seconds' },
                    { value: 60, text: '60 Seconds' },
                    { value: 120, text: '120 Seconds' },
                    { value: 180, text: '180 Seconds' },
                ],

                selectedFormat: 'xlsx',
                formatOptions: [
                    { value: 'xlsx', text: 'Excel spreedsheet (.xlsx)' },
                    { value: 'csv', text: 'Comma separated (.csv)' },
                ],

                selectedUnit: 'kph',
                unitOptions: [
                  { value: 'kph', text: 'Kilometers\\Hour' },
                  { value: 'mph', text: 'Miles\\Hour' },
                ],
            }
        },
        computed: {
            ...mapGetters({
                organization: 'organization/current',
                selectOrganization: 'organization/select',

                session: 'session/current',
                sessionLoading: 'session/currentLoadingOrNull',
                sessionName: 'session/currentName',
            }),

            showInProgressWarning() {
              return !this.sessionLoading && this.session && this.session.isComplete == false;
            },

        },
        created () {
          this.resetModel(this.organization);
        },
        watch: {
          showModal(newValue) {
            if(newValue) {
              this.resetModel(this.organization);
            }
          },
          organization(newValue) {
            this.resetModel(newValue);
          },
        },
        methods: {
          resetModel(newValue) {

            if (newValue) {
              this.primaryImageValue = newValue.primaryImage;
              this.primaryImageValid = newValue.replaceReportImage && this.primaryImageValue && this.primaryImageValue.length > 0;
            } else {
              this.primaryImageValid = false;
              this.primaryImageValue = null;
            }
          },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                api.downloadMeasurementReport(
                    this.organization.organizationId,
                    this.session.sessionId,
                    this.selectedAverage,
                    this.selectedFormat,
                    this.selectedUnit,
                    this.includePDFReport,
                    this.includeDataTables,
                    this.includeExtendedDataTables);

                this.closeModal()
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                this.closeModal()
            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('report-measurement-modal')
                })
            }
        }
    }
</script>

<style scoped>

</style>